<template>
    <div>
        <div :class="`form-group ${isPageType(ID_PAGE_TYPE.A) ? '' : 'row'}`">
            <label class="col-sm-1" style="max-width: fit-content"> {{ $t('managerForm.analytics.optionFilterSubmit') }}</label>
            <div class="col-sm-10">
                <div class="d-flex">
                    <div v-for="item in CHOICE_CONDITION_FILTER" :key="item.id">
                        <InputRadio
                            class="mr-4"
                            :model.sync="typeFilter"
                            :name="`choiceFilter`"
                            :id="`choiceFilter-${item.id}`"
                            :value="item.value"
                            :label="item.label"
                        />
                    </div>
                </div>
            </div>
        </div>

        <table class="table table-bordered">
            <thead>
                <th
                    v-for="(item, k) in configconfigTableFilterBlocks.headers"
                    :key="k"
                    style="background: #ededed"
                    :style="`min-width: ${item.width}px`"
                >
                    <div class="d-flex align-items-center">{{ item.label }}</div>
                </th>
            </thead>
            <tbody>
                <tr v-for="(blockItem, idx) in ITEM_BLOCKS" :key="idx">
                    <td>
                        <Multiselect
                            style="min-width: 180px"
                            :id="`select-block-saved-${idx}`"
                            :value.sync="blockItem.block_item"
                            :options="BLOCK_LIST"
                            :config="{ trackBy: 'id', label: 'block_name', error: false, isRemove: true }"
                            @select="handleSelectBlock(blockItem)"
                        />
                    </td>
                    <td>
                        <div>
                            <Multiselect
                                style="min-width: 180px"
                                :id="`select-type_condition-${idx}`"
                                :value.sync="blockItem.conditions"
                                :options="TYPE_CONDITION_IN_TABLE"
                                :config="{ trackBy: 'id', label: 'name', error: false, isRemove: true }"
                                @open="handleOpenTypeCondition(blockItem)"
                                @select="handleSelectTypeCondition(blockItem)"
                            />
                        </div>
                    </td>
                    <td>
                        <div v-if="![5, 6].includes(blockItem.conditions?.id)">
                            <template
                                v-if="
                                    [
                                        ALL_BLOCK_TYPE.BLOCK_SELECT,
                                        ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                                        ALL_BLOCK_TYPE.BLOCK_RADIO,
                                        ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                                        ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
                                    ].includes(blockItem?.block_item?.block_type)
                                "
                            >
                                <Multiselect
                                    style="min-width: 180px"
                                    :id="`select-type_condition-${idx}`"
                                    :value.sync="blockItem.select_value_block"
                                    :options="onHandleGetOption(blockItem?.block_item?.block_type, blockItem?.block_item?.options, blockItem)"
                                    :config="{
                                        trackBy: 'id',
                                        label: 'value',
                                        multiple: conditionTypeOther.includes(blockItem.conditions?.id),
                                        error: false,
                                        isRemove: true
                                    }"
                                />
                            </template>
                            <template v-else-if="[ALL_BLOCK_TYPE.BLOCK_DATE, SUBMITED_AT, UPDATED_AT].includes(blockItem?.block_item?.block_type)">
                                <PickerDate :id="`searchBlockDate${idx}`" :model.sync="blockItem.value_block" />
                            </template>
                            <template v-else-if="blockItem?.block_item?.block_type == ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER">
                                <div class="d-flex align-items-center flex-nowrap" :style="`gap: 10px; `">
                                    <InputText
                                        :id="`InputPhone-1-Form-${idx}`"
                                        :model.sync="blockItem.value_phone_1"
                                        style="max-width: 80px"
                                        :config="{
                                            maxlength: 5,
                                            isNumber: true,
                                            error: false,
                                            isTrim: true
                                        }"
                                    />
                                    <div class="p-1" style="font-size: 20px">-</div>
                                    <InputText
                                        :id="`InputPhone-2-Form-${idx}`"
                                        :model.sync="blockItem.value_phone_2"
                                        style="max-width: 80px"
                                        :config="{
                                            maxlength: 4,
                                            isNumber: true,
                                            error: false,
                                            isTrim: true
                                        }"
                                    />
                                    <div class="p-1" style="font-size: 20px">-</div>
                                    <InputText
                                        :id="`InputPhone-3-Form-${idx}`"
                                        :model.sync="blockItem.value_phone_3"
                                        style="max-width: 80px"
                                        :config="{
                                            maxlength: 4,
                                            isNumber: true,
                                            error: false,
                                            isTrim: true
                                        }"
                                    />
                                </div>
                            </template>
                            <template v-else-if="blockItem?.block_item?.block_type == ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE">
                                <div class="d-flex align-items-center flex-nowrap" :style="`gap: 10px; `">
                                    <InputText
                                        :id="`InputPostcode-1-Form-${idx}`"
                                        :model.sync="blockItem.value_postal_code_1"
                                        style="max-width: 80px"
                                        :config="{
                                            maxlength: 3,
                                            isNumber: true,
                                            error: false,
                                            isTrim: true
                                        }"
                                    />
                                    <div class="p-1" style="font-size: 20px">-</div>
                                    <InputText
                                        :id="`InputPostcode-2-Form-${idx}`"
                                        :model.sync="blockItem.value_postal_code_2"
                                        style="max-width: 80px"
                                        :config="{
                                            maxlength: 4,
                                            isNumber: true,
                                            error: false,
                                            isTrim: true
                                        }"
                                    />
                                </div>
                            </template>
                            <template v-else-if="blockItem?.block_item?.block_type == ALL_BLOCK_TYPE.BLOCK_FULL_NAME">
                                <div class="d-flex align-items-center flex-nowrap" :style="`gap: 10px; `">
                                    <InputText
                                        :id="`InputPostcodeUser-First_Name-Form-${idx}`"
                                        :model.sync="blockItem.value_first_name"
                                        style="max-width: 100px"
                                        :config="{
                                            placeholder: $t('managerForm.settingPage.firstName'),
                                            maxlength: 255,
                                            error: false,
                                            isTrim: true
                                        }"
                                    />
                                    <div class="p-1" style="font-size: 20px">-</div>
                                    <InputText
                                        :id="`User-Last_Name-Form-${idx}`"
                                        :model.sync="blockItem.value_last_name"
                                        style="max-width: 100px"
                                        :config="{
                                            placeholder: $t('managerForm.settingPage.lastName'),
                                            maxlength: 255,
                                            error: false,
                                            isTrim: true
                                        }"
                                    />
                                </div>
                            </template>
                            <template v-else>
                                <InputText
                                    :id="`input-value_block-${idx}`"
                                    style="min-width: 180px"
                                    :model.sync="blockItem.value_block"
                                    :config="{
                                        error: false,
                                        isTrim: true
                                    }"
                                />
                            </template>
                        </div>
                    </td>
                    <td style="width: 100px">
                        <div class="text-left text-nowrap">
                            <button
                                :disabled="ITEM_BLOCKS.length === 1"
                                type="button"
                                class="btn btn-common-sml btn-danger"
                                @click="handleDeleteConditionBlock(idx)"
                            >
                                <i class="ri-delete-bin-2-line"></i>{{ $t('btn.delete') }}
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="text-right text-nowrap mt-3 mr-4">
            <button type="button" class="btn btn-common-sml btn-outline-success" @click="handleAddFilterConditionBlock">
                <span>{{ $t('managerForm.settingPage.add') }}</span>
            </button>
        </div>
        <div v-if="!hideActionButtons && isPageType(ID_PAGE_TYPE.A)" class="text-center text-nowrap">
            <button type="button" @click="handleClearSearch" class="btn btn-common btn-outline-primary">
                <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
            </button>
            <button type="button" @click="handleFilterResult" class="btn btn-common btn-primary ml-3">
                <i class="ri-search-line"></i>{{ $t('btn.search') }}
            </button>
        </div>
    </div>
</template>

<script>
import { configs } from '../../constants';
import { InputText, InputRadio } from '@/components/Input';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { VALUE_ETC, VALUE_NAC } from '../../../iframe-page/handlers';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';

import Multiselect from '@/components/Multiselect/main.vue';
import PickerDate from '@/components/DateCustoms/PickerDate/main.vue';

export default {
    name: 'TableFilter',
    props: {
        blockList: {
            type: Array,
            default: () => []
        },
        currentTypePage: {
            type: [Number, String],
            default: () => ID_PAGE_TYPE.A
        },
        hideActionButtons: {
            type: Boolean,
            default: false
        }
    },
    components: {
        InputText,
        Multiselect,
        PickerDate,
        InputRadio
    },
    computed: {
        isPageType() {
            return (pageType) => this.currentTypePage === pageType;
        }
    },
    data() {
        return {
            ID_PAGE_TYPE,
            configconfigTableFilterBlocks: configs.configTableFilterBlock,
            CHOICE_CONDITION_FILTER: configs.CHOICE_CONDITION_FILTER,
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            VALUE_ETC: VALUE_ETC,
            VALUE_NAC: VALUE_NAC,
            ITEM_BLOCKS: [this.initVarTableFilter()],
            TYPE_CONDITION_IN_TABLE: [],
            BLOCK_LIST: [],
            conditionTypeOther: [7, 8],
            SUBMITED_AT: 'submitted_at',
            UPDATED_AT: 'updated_at',
            typeFilter: 'AND'
        };
    },
    methods: {
        onInitFilterConditions() {
            return [
                { id: 1, value: 'equal', name: 'イコール' },
                { id: 2, value: 'start_with', name: '前方一致' },
                { id: 3, value: 'end_with', name: '後方一致' },
                { id: 4, value: 'include', name: '含む' },
                { id: 5, value: 'no_answer', name: '回答なし' },
                { id: 6, value: 'has_answer', name: '回答あり' },
                { id: 7, value: 'select_one', name: 'いずれか選択' },
                { id: 8, value: 'select_all', name: 'すべて選択' },
                { id: 9, value: 'gt_equal', name: 'より後' },
                { id: 10, value: 'lt_equal', name: 'より前' }
            ];
        },

        handleSelectBlock(evt) {
            evt.conditions = null;
            this.onResetInforBlock(evt);
        },

        onResetInforBlock(pEvt) {
            pEvt.value_block = null;
            pEvt.select_value_block = null;
            pEvt.value_phone_1 = null;
            pEvt.value_phone_2 = null;
            pEvt.value_phone_3 = null;
            pEvt.value_postal_code_1 = null;
            pEvt.value_postal_code_2 = null;
            pEvt.value_first_name = null;
            pEvt.value_last_name = null;
        },

        handleOpenTypeCondition(evtBlock) {
            if (!evtBlock?.block_item) {
                this.TYPE_CONDITION_IN_TABLE = [];
                return;
            }
            switch (evtBlock.block_item.block_type) {
                case ALL_BLOCK_TYPE.BLOCK_INPUT:
                case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
                case ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION:
                case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [1, 2, 3, 4, 5, 6].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                case ALL_BLOCK_TYPE.BLOCK_SELECT:
                case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [5, 6, 7].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_TEXTAREA:
                case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [5, 6].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [5, 6, 7, 8].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_DATE:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [1, 5, 6, 9, 10].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [1, 2, 5, 6].includes(item.id);
                    });
                    break;
                case this.SUBMITED_AT:
                case this.UPDATED_AT:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [1, 9, 10].includes(item.id);
                    });
                    break;
            }
        },

        handleSelectTypeCondition(evtBlock) {
            if ([5, 6].includes(evtBlock.conditions?.id)) {
                this.onResetInforBlock(evtBlock);
            }
        },
        initVarTableFilter() {
            return {
                block_item: null,
                conditions: null,
                select_value_block: null,
                value_block: null,
                value_phone_1: null,
                value_phone_2: null,
                value_phone_3: null,
                value_postal_code_1: null,
                value_postal_code_2: null,
                value_first_name: null,
                value_last_name: null
            };
        },

        handleAddFilterConditionBlock() {
            this.ITEM_BLOCKS.push(this.initVarTableFilter());
        },

        handleDeleteConditionBlock(idx) {
            this.ITEM_BLOCKS.splice(idx, 1);
        },

        handleFilterResult() {
            let query = [];
            for (let i = 0; i < this.ITEM_BLOCKS.length; i++) {
                const item = this.ITEM_BLOCKS[i];
                const startWidth = [2].includes(item.conditions?.id);
                const endWidth = [3].includes(item.conditions?.id);
                if (item.block_item?.id && item.conditions?.value) {
                    query.push(`searchCriteria[filterGroups][condition]=${this.typeFilter}`);
                    let valueQuery = '';
                    switch (item.block_item?.block_type) {
                        case ALL_BLOCK_TYPE.BLOCK_RADIO:
                        case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                            if (this.conditionTypeOther.includes(item.conditions?.id)) {
                                item.select_value_block.forEach((item) => {
                                    if (item.id === VALUE_ETC) {
                                        query.push(`searchCriteria[filterGroups][0][filter_blocks][${i}][is_custom_value]=true`);
                                    }
                                });
                                valueQuery = item.select_value_block?.filter((item) => item.id !== VALUE_ETC).map((item) => item.value);
                            } else {
                                valueQuery = item.select_value_block?.value_search;
                            }
                            break;
                        case ALL_BLOCK_TYPE.BLOCK_SELECT:
                        case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                        case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                            valueQuery = this.conditionTypeOther.includes(item.conditions?.id)
                                ? item.select_value_block?.map((item) => item.value)
                                : item.select_value_block?.value_search;
                            break;
                        case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                            if (startWidth) {
                                if (item.value_postal_code_1) {
                                    valueQuery = item.value_postal_code_1;
                                    if (item.value_postal_code_2) {
                                        valueQuery = `${item.value_postal_code_1}-${item.value_postal_code_2}`;
                                    }
                                }
                            } else {
                                valueQuery =
                                    item.value_postal_code_1 && item.value_postal_code_2
                                        ? `${item.value_postal_code_1}-${item.value_postal_code_2}`
                                        : '';
                            }
                            break;
                        case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                            if (startWidth) {
                                if (item.value_phone_1) {
                                    valueQuery = item.value_phone_1;
                                    if (item.value_phone_2) {
                                        valueQuery = `${item.value_phone_1}-${item.value_phone_2}`;
                                        if (item.value_phone_3) {
                                            valueQuery = `${item.value_phone_1}-${item.value_phone_2}-${item.value_phone_3}`;
                                        }
                                    }
                                }
                            } else {
                                valueQuery =
                                    item.value_phone_1 && item.value_phone_2 && item.value_phone_3
                                        ? `${item.value_phone_1}-${item.value_phone_2}-${item.value_phone_3}`
                                        : '';
                            }
                            break;
                        case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                            if (startWidth) {
                                if (item.value_first_name) {
                                    valueQuery = item.value_first_name;
                                    if (item.value_last_name) {
                                        valueQuery = `${item.value_first_name} ${item.value_last_name}`;
                                    }
                                }
                            } else if (endWidth) {
                                if (item.value_last_name) {
                                    valueQuery = item.value_last_name;
                                    if (item.value_first_name) {
                                        valueQuery = `${item.value_first_name} ${item.value_last_name}`;
                                    }
                                }
                            } else {
                                valueQuery =
                                    item.value_first_name || item.value_last_name
                                        ? `${item?.value_first_name ?? ''} ${item?.value_last_name ?? ''}`
                                        : '';
                            }
                            break;

                        default:
                            valueQuery = item.value_block ? item.value_block : '';
                            break;
                    }
                    if (![this.SUBMITED_AT, this.UPDATED_AT].includes(item.block_item?.block_type)) {
                        query.push(`searchCriteria[filterGroups][0][filter_blocks][${i}][block_id]=${item.block_item?.id ?? ''}`);
                        query.push(`searchCriteria[filterGroups][0][filter_blocks][${i}][block_type]=${item.block_item?.block_type ?? ''}`);
                        query.push(`searchCriteria[filterGroups][0][filter_blocks][${i}][condition_type]=${item.conditions?.value ?? ''}`);
                        if (Array.isArray(valueQuery)) {
                            valueQuery.forEach((val) => {
                                query.push(`searchCriteria[filterGroups][0][filter_blocks][${i}][value][]=${encodeURIComponent(val)}`);
                            });
                        } else {
                            query.push(`searchCriteria[filterGroups][0][filter_blocks][${i}][value]=${valueQuery ? valueQuery : null}`);
                        }
                    }
                }

                if ([this.SUBMITED_AT, this.UPDATED_AT].includes(item.block_item?.block_type)) {
                    query.push(`searchCriteria[filterGroups][1][filter_result][${i}][field]=${item.block_item?.block_type ?? ''}`);
                    query.push(`searchCriteria[filterGroups][1][filter_result][${i}][condition_type]=${item.conditions?.value ?? ''}`);
                    query.push(`searchCriteria[filterGroups][1][filter_result][${i}][value]=${item.value_block ?? ''}`);
                }
            }
            this.$emit('onQuery', query.join('&'));
        },

        handleClearSearch() {
            this.ITEM_BLOCKS = [this.initVarTableFilter()];
            this.typeFilter = 'AND';
            this.$emit('onQuery', '');
        },

        onHandleGetOption(blockType, options, blockOrigin) {
            if (!blockType || !options) return [];
            const optionsValue = options.map((item) => {
                item.value_search = item.value;
                return item;
            });
            switch (blockType) {
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    if (this.conditionTypeOther.includes(blockOrigin.conditions?.id)) {
                        if (blockOrigin.block_item.extension.setting_others.other_use) {
                            return [
                                ...optionsValue,
                                {
                                    id: VALUE_ETC,
                                    value_search: blockOrigin.block_item.extension.setting_others.label_other,
                                    value: blockOrigin.block_item.extension.setting_others.label_other
                                }
                            ];
                        } else {
                            return optionsValue;
                        }
                    } else {
                        return optionsValue;
                    }
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    if (this.conditionTypeOther.includes(blockOrigin.conditions?.id)) {
                        const condition_1 =
                            blockOrigin.block_item.extension.setting_others.other_use && blockOrigin.block_item.extension.setting_others.uncheck_use;
                        const condition_2 =
                            blockOrigin.block_item.extension.setting_others.other_use && !blockOrigin.block_item.extension.setting_others.uncheck_use;
                        const condition_3 =
                            !blockOrigin.block_item.extension.setting_others.other_use && blockOrigin.block_item.extension.setting_others.uncheck_use;
                        if (condition_1) {
                            return [
                                ...optionsValue,
                                {
                                    id: VALUE_ETC,
                                    value_search: blockOrigin.block_item.extension.setting_others.label_other,
                                    value: blockOrigin.block_item.extension.setting_others.label_other
                                },
                                {
                                    id: VALUE_NAC,
                                    value_search: blockOrigin.block_item.extension.setting_others.label_uncheck,
                                    value: blockOrigin.block_item.extension.setting_others.label_uncheck
                                }
                            ];
                        }
                        if (condition_2) {
                            return [
                                ...optionsValue,
                                {
                                    id: VALUE_ETC,
                                    value_search: blockOrigin.block_item.extension.setting_others.label_other,
                                    value: blockOrigin.block_item.extension.setting_others.label_other
                                }
                            ];
                        }
                        if (condition_3) {
                            return [
                                ...optionsValue,
                                {
                                    id: VALUE_NAC,
                                    value_search: blockOrigin.block_item.extension.setting_others.label_uncheck,
                                    value: blockOrigin.block_item.extension.setting_others.label_uncheck
                                }
                            ];
                        }
                        return optionsValue;
                    } else {
                        return optionsValue;
                    }
                default:
                    return optionsValue;
            }
        }
    },
    watch: {
        blockList: {
            handler() {
                this.BLOCK_LIST =
                    [
                        ...this.blockList?.filter(
                            (item) => ![ALL_BLOCK_TYPE.BLOCK_DISPLAY_1, ALL_BLOCK_TYPE.BLOCK_DISPLAY_2].includes(item.block_type)
                        ),
                        { id: this.SUBMITED_AT, block_type: this.SUBMITED_AT, block_name: '回答日時' }
                    ] ?? [];
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
